module.exports = __webpack_public_path__ + "img/12_34.1b2ef5c1.png";